/**
 * Mobile Standings Preview Component
 * Compact standings for League Home — renders via the shared StandTable.
 */
import React, { useState } from 'react';
import { dynastyTheme } from '../../../services/colorService';
import StandTable from './StandTable';

const C = dynastyTheme.tokens.colors;

const MobileStandingsPreview = ({ standings, onViewFull, userTeamId, leagueId }) => {
  const [sortConfig, setSortConfig] = useState({ key: 'totalPoints', direction: 'desc' });

  const handleSort = (key) => {
    setSortConfig(prevConfig => ({
      key,
      direction: prevConfig.key === key && prevConfig.direction === 'desc' ? 'asc' : 'desc'
    }));
  };

  if (!standings || !standings.teams || standings.teams.length === 0) {
    return (
      <div className="text-center py-8">
        <p className={dynastyTheme.classes.text.neutralLight}>Loading standings...</p>
      </div>
    );
  }

  // User-team highlight color from the CSS theme variable (preview context).
  const userTeamPrimary = typeof document !== 'undefined'
    ? getComputedStyle(document.documentElement).getPropertyValue('--team-primary').trim()
    : undefined;

  // No "Through {date}" line here — League Home's section header already shows it (right
  // meta); a second copy inflated the gap below the STANDINGS label. maxHeight 'none' →
  // all teams render flush (no vertical scroll / bar).
  return (
    <div>
      <StandTable
        data={standings}
        sortConfig={sortConfig}
        onSort={handleSort}
        userTeamId={userTeamId}
        userTeamPrimary={userTeamPrimary}
        leagueId={leagueId}
        maxHeight="none"
      />
    </div>
  );
};

export default MobileStandingsPreview;
